(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("theme_yota", [], factory);
	else if(typeof exports === 'object')
		exports["theme_yota"] = factory();
	else
		root["theme_yota"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 